import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

//fund wallet with voucher
export function fundWalletWithVoucher(voucherObj, walletId){
  const url = `${BASE_URL}/wallets/` + walletId + `/fund`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  
  console.log(token);
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      source:voucherObj.source,
      voucher:{
        code:voucherObj.code
      },
      medium:'web'
    },
  })
  
}

//fund wallet with rave
export function fundWalletWithRave(raveObj, walletId){
  const url = `${BASE_URL}/wallets/` + walletId + `/fund`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  
  console.log(token);
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      source:raveObj.source,
      sender:{
        first_name:raveObj.firstName,
        last_name:raveObj.lastName,
        email:raveObj.email,
        phone_number: raveObj.phoneNumber,
      },
      amount:raveObj.amount,
      medium:'web',
      redirect_url:raveObj.redirectUrl,
    },
  })
  
}

//fund wallet with linked card
export function fundWalletWithLinkedCard(cardObj, walletId){
  const url = `${BASE_URL}/wallets/` + walletId + `/fund`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  
  console.log(token);
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      source:cardObj.source,
      sender:{
        first_name:cardObj.firstName,
        last_name:cardObj.lastName,
        email:cardObj.email,
        phone_number: cardObj.phoneNumber,
      },
      amount:cardObj.amount,
      medium:'web',
      redirect_url:cardObj.redirectUrl,
    },
  })
  
}

//fund wallet with another wallet currency
export function fundWalletWithWallet(walletObj, walletId){
  const url = `${BASE_URL}/wallets/` + walletId + `/fund`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  
  console.log(token);
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      source:walletObj.source,
      medium:'web',
      wallet:{
        uref:walletObj.uref,
        password:walletObj.password,
      },
      amount:walletObj.amount
    },
  })
  
}



// WEBPACK FOOTER //
// ./src/utils/wallet-transactions/fundWalletService.js